import TestimonialBg from "../../../../assets/images/testimonial/testimonial-bg.png";
import ALogo from "../../../../assets/images/a-logo.png";

const Testimonial = ({ img = "", content = "", name = "", role = "",location="" ,logo = ALogo,logoSize="80px",imgMargin="0px"}) => {
    return (
        <div
            className="card p-3 bg-white shadow"
            style={{
                backgroundImage: `url(${TestimonialBg})`,
                backgroundPosition: "center 7.5rem",
                backgroundSize: "5rem",
                backgroundRepeat: "no-repeat",
                borderRadius : "1rem",
                maxWidth : "26rem"
            }}
        >
            <img
                className="position-absolute start-50 translate-middle rounded-circle"
                style={{ width: "50%" , maxWidth : "11rem" }}
                src={img}
                alt=""
            />
            <div className="d-flex flex-column h-100" style={{ marginTop: "7rem"}}>
                <p className="text-center text-2 text-quote flex-fill d-flex align-items-center" style={{ fontWeight : "400" }}>{content}</p>
                <div className="text-center text-2 text-body-2">
                    <span>{name}</span>
                    <span className="fw-blod"> | </span>
                    <span className="text-primary">{role}</span>
                    <div>{location}</div>
                </div>
                <div className="d-flex justify-content-center py-3">
                    <img src={logo} height={logoSize} alt="" style={{margin:`${imgMargin} 0`}} />
                </div>
            </div>
        </div>
    );
};

export default Testimonial;
